import { SupplierPaymentsPage } from '../payments/supplier-payments';

/** Alias de menú Finanzas → Por Pagar: abre directo la pestaña de deudas */
export function PayablesPage() {
  return <SupplierPaymentsPage defaultTab="pending" />;
}
